<template>
  <div class="container mt-5">
    <div class="w-100 d-flex flex-column align-items-center">
      <div class="ui-loading"></div>
    </div>
  </div>

</template>

<script>
export default {
name: "loading",
  props:[
    'data',
  ]
}
</script>

<style scoped>

</style>
